import { h } from "preact";

import IconProps from "./IconProps";

function IconChecked({ color, width, height, class: cssClass }: IconProps) {
    return (
        <svg class={cssClass} width={width} height={height}>
            <path fill={color} fill-rule="evenodd" d="M16 0H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zM7 14L2 9.2l1.4-1.35L7 11.3 14.6 4 16 5.35 7 14z"/>
        </svg>
    );
}

IconChecked.defaultProps = {
    color: "var(--cornflower-blue)",
    width: 18,
    height: 18
};

export default IconChecked;
